import React, { Component } from 'react'
import "./project.scss"
import Header from '../../components/Header/header'
import Footer from '../../components/Footer/footer'
import { getApiCategoryList , getApigetCuslocationList } from '../../axios/api'
import { Pagination } from 'antd';
import 'antd/dist/antd.css';

export default class project extends Component {

    state = {
        page:1,
        total:1,
        showMore:false,
        arr:[],
        demand:[],
        area:[],
        city:[],

        areaType:"",
        intention:"",
        industry:"",
    }

    componentWillMount(){
        window.scroll(0,0);

        getApiCategoryList()
        .then( req =>{
            if(req.data.code === 1){
                let data = req.data.data;
                this.setState({
                    demand:data.demand,
                    area:data.area,
                    city:data.city,
                })
            }
        }).catch( err =>{
            console.error(err);
        })

        this.changePage(1);
    }

    gotoPage=(page)=>{
        this.props.history.push(page);
    }

    gotoInfoPage=(page)=>{
 
        let str = window.location.href;
        var num=str.indexOf("#/") 
        str=str.substr(0,num+1); //取得所有参数   stringvar.substr(start [, length ]

        window.open(str + page);
    }

    changePage=(page)=>{
        this.setState({
            page
        })

        console.log(page);

        setTimeout(()=>{
            window.scroll(0,0)
            this.getList()
        },50)
    }

    getList=()=>{

        let param = {
            area:this.state.areaType,
            industry:this.state.industry,
            intention:this.state.intention,
            page:this.state.page
        }

        getApigetCuslocationList(param)
        .then( req =>{
            if(req.data.code === 1){
                let data = req.data.data;
                this.setState({
                    arr:data.list,
                    total:data.total
                })
            }
        }).catch( err =>{
            console.error(err);
        })
    }

    render() {
        return (
            <div className='project'>
                <Header type={10} />
                <div className='head'>
                    <div className='cen'>
                        <div className='hmain'>
                            <div className='hname'>
                                <p>当前位置：</p>
                                <p className='i_point' onClick={()=>{this.gotoPage('/')}}>首页</p>
                                <img alt="" src="/www/assets/imgs/xiaji.png" />
                                <p>潜在招商项目</p>
                            </div>

                            <div className='hbox'>
                                
                                <div className='hdiv'>
                                    <h2>意向地区：</h2>
                                    <div className={this.state.showMore?'hflex hauto':'hflex'}>
                                        <div onClick={()=>{this.setState({intention:""});this.changePage(1)}} className={this.state.intention === ""?"chosn":""}>全部</div>
                                        {
                                            this.state.city.map((item,index)=>{
                                                return <div key={index} onClick={()=>{this.setState({intention:item});this.changePage(1)}} className={this.state.intention === item?"chosn":""}>{item}</div>
                                            })
                                        }

                                        <div className='more' onClick={()=>{this.setState({showMore:!this.state.showMore})}}>
                                            <p>{this.state.showMore?"收起":"更多"}</p>
                                            <img alt="" src={this.state.showMore?"/www/assets/imgs/gengduo2.png":"/www/assets/imgs/gengduo.png"} />
                                        </div>
                                    </div>
                                </div>

                                <div className='hdiv'>
                                    <h2>需求面积：</h2>
                                    <div className='hflex'>
                                        <div onClick={()=>{this.setState({areaType:""});this.changePage(1)}} className={this.state.areaType === ""?"chosn":""}>全部</div>
                                        {
                                            this.state.area.map((item,index)=>{
                                                return <div onClick={()=>{this.setState({areaType:item.value});this.changePage(1)}} className={this.state.areaType === item.value?"chosn":""}>{item.name}</div>
                                            })
                                        }
                                    </div>
                                </div>

                                <div className='hdiv'>
                                    <h2>需求载体：</h2>
                                    <div className='hflex'>
                                        <div onClick={()=>{this.setState({industry:""});this.changePage(1)}} className={this.state.industry === ""?"chosn":""}>全部</div>
                                        {
                                            this.state.demand.map((item,index)=>{
                                                return <div onClick={()=>{this.setState({industry:item.id});this.changePage(1)}} className={this.state.industry === item.id?"chosn":""}>{item.name}</div>
                                            })
                                        }
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div className='page'>
                    <div className='cen'>
                        <div className='main'>
                            <div className='box'>
                                {
                                    this.state.arr.map((item,index)=>{
                                        return <div className='card' key={index} onClick={()=>{this.gotoInfoPage('/projectinfo?id='+item.id)}}>
                                                    <div className='top'>
                                                        <h2>{item.title}</h2>
                                                        <p>意向区域：{item.intention}</p>
                                                        <p>产业类型：{item.industry_text}</p>
                                                        <div>
                                                            <img alt="" src="/www/assets/imgs/xiaochengxu.png" className='timg' />
                                                        </div>
                                                        
                                                    </div>
                                                    <div className='bom'>
                                                        <div className='bitem'>
                                                            <h2>{item.investment}万元</h2>
                                                            <p>投资总额</p>
                                                        </div>
                                                        <div className='bitem'>
                                                            <h2>{item.revenue}万元</h2>
                                                            <p>预期税收</p>
                                                        </div>
                                                        <div className='bitem'>
                                                            <h4>{item.createtime}</h4>
                                                            <p>发布时间</p>
                                                        </div>
                                                    </div>
                
                                                    <div className={item.show?'mark show':'mark'}>
                                                        <div className='mleft'>
                                                            <img alt="" className='mimg' src={item.code_img} />
                                                            <h2>扫一扫关注服务站</h2>
                                                        </div>
                                                        <div className='minfo'>
                                                            <h2>灵一招商小程序</h2>
                                                            <p>南京北大科技园科技发展有限公司</p>
                                                            <div>写字楼/园区数字化招商工具，包括招商获客、产业地图、客户管理、租控管理、便捷分享等功能。</div>
                                                        </div>
                                                    </div>
                                                </div>
                                    })
                                }
                            </div>
                            <div className='r_page'>
                                <Pagination type="success" showSizeChanger={false} pageSize={9}  current={this.state.page} total={this.state.total} onChange={(page)=>{this.changePage(page)}} />
                            </div>
                        </div>
                    </div>
                </div>

                <Footer />
            </div>
        )
    }
}
